import { useState } from 'react';
import axios from 'axios';

function WhatsAppForm() {
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [response, setResponse] = useState('');
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setResponse('Please log in again.');
        setIsError(true);
        return;
      }
      const res = await axios.post(
        'https://whats-app.360websitedemo.com/api/whatsapp/send',
        { phone, message },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setResponse(res.data.message);
      setIsError(false);
      setPhone('');
      setMessage('');
    } catch (error) {
      console.error('Form submission error:', error);
      setResponse(error.response?.data?.error || 'Failed to send message');
      setIsError(true);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3 className="text-md font-semibold mb-4">WhatsApp Number</h3>
      <input
        type="tel"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        className="w-full p-2 border border-gray-300 rounded mb-4"
        placeholder="+918849192050"
        required
      />
      <h3 className="text-md font-semibold mb-4">Message</h3>
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        className="w-full p-2 border border-gray-300 rounded mb-4"
        rows="4"
        placeholder="Enter your message here..."
        required
      ></textarea>
      <p className="text-gray-500 text-sm mb-4">0/1000</p>
      <button
        type="submit"
        className="bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
      >
        Send Message
      </button>
      {response && (
        <p className={`mt-4 ${isError ? 'text-red-500' : 'text-green-600'}`}>
          {response}
        </p>
      )}
    </form>
  );
}

export default WhatsAppForm;